virtual task receive{{#if isPipelinedRead}}_response{{/if}}({{ sequenceItemHandle.type }} {{ sequenceItemHandle.identifier }});
  store_transaction({{ sequenceItemHandle.identifier }});
{{#if isPipelinedRead}}
  wait ({{ sequenceItemHandle.identifier }}.{{ sequenceItemHandle.klass.beatIndexVariable.identifier }} == {{ sequenceItemHandle.identifier }}.{{ sequenceItemHandle.klass.lenVariable.identifier }});
{{else}}
  {{ sequenceItemHandle.identifier }}.wait_for_resp();
{{/if}}
  drop_transaction({{ sequenceItemHandle.identifier }});
endtask
